import { render, staticRenderFns } from "./AgingInventories.vue?vue&type=template&id=2c60c1b2&scoped=true&"
import script from "./AgingInventories.vue?vue&type=script&lang=js&"
export * from "./AgingInventories.vue?vue&type=script&lang=js&"
import style0 from "./AgingInventories.vue?vue&type=style&index=0&id=2c60c1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60c1b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c60c1b2')) {
      api.createRecord('2c60c1b2', component.options)
    } else {
      api.reload('2c60c1b2', component.options)
    }
    module.hot.accept("./AgingInventories.vue?vue&type=template&id=2c60c1b2&scoped=true&", function () {
      api.rerender('2c60c1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/availableInventories/AgingInventories.vue"
export default component.exports